/* sg-pdp: galería, variantes, cantidad, medidas, favorito y contador de la ficha de producto. */
if (!customElements.get('sg-pdp')) {
  class SgPdp extends HTMLElement {
    connectedCallback() {
      const data = this.querySelector('[data-sg-variants]');
      this.data = data ? JSON.parse(data.textContent) : { variants: [] };
      this.variants = this.data.variants;

      this.stage = this.querySelector('[data-sg-stage]');
      this.slides = [...this.querySelectorAll('.sg-pdp__slide')];
      this.thumbs = [...this.querySelectorAll('.sg-pdp__thumb')];
      this.idInput = this.querySelector('[data-sg-variant-id]');
      this.qty = this.querySelector('[data-sg-qty]');
      this.add = this.querySelector('[data-sg-add]');
      this.now = this.querySelector('[data-sg-now]');

      this.thumbs.forEach((t) => t.addEventListener('click', () => this.showMedia(t.dataset.mediaId)));

      this.querySelectorAll('.sg-pdp__option input').forEach((input) => {
        input.addEventListener('change', () => this.onOption());
      });

      const dec = this.querySelector('[data-sg-dec]');
      const inc = this.querySelector('[data-sg-inc]');
      if (dec) dec.addEventListener('click', () => this.setQty(this.value() - 1));
      if (inc) inc.addEventListener('click', () => this.setQty(this.value() + 1));
      if (this.qty) this.qty.addEventListener('input', () => this.syncNow());

      this.initShare();
      this.initGuide();
      this.initDims();
      this.initDiagram();
      this.initFav();
      this.initCountdown();
      this.current = this.findVariant();
      if (this.current) this.render(this.current, false);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    value() {
      return Math.max(1, parseInt(this.qty && this.qty.value, 10) || 1);
    }

    setQty(n) {
      this.qty.value = Math.min(99, Math.max(1, n));
      this.syncNow();
    }

    syncNow() {
      if (!this.now || !this.current) return;
      this.now.href = `${this.now.dataset.base}/${this.current.id}:${this.value()}`;
    }

    selected() {
      return [...this.querySelectorAll('.sg-pdp__option')].map((f) => {
        const checked = f.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    findVariant() {
      if (!this.querySelector('.sg-pdp__option')) return this.variants[0];
      const sel = this.selected();
      return this.variants.find((v) => v.options.every((o, i) => o === sel[i])) || null;
    }

    onOption() {
      this.querySelectorAll('.sg-pdp__option').forEach((f) => {
        const checked = f.querySelector('input:checked');
        const label = f.querySelector('[data-sg-option-label]');
        if (checked && label) label.textContent = checked.value;
      });
      const variant = this.findVariant();
      if (!variant) {
        if (this.add) { this.add.disabled = true; this.add.querySelector('span').textContent = this.add.dataset.labelSold; }
        return;
      }
      this.current = variant;
      this.render(variant, true);
    }

    render(v, changed) {
      const set = (sel, text) => { const el = this.querySelector(sel); if (el) el.textContent = text; };
      set('[data-sg-price]', v.price);
      const hasDiscount = v.has_discount;
      this.querySelectorAll('[data-sg-was-wrap],[data-sg-save-wrap],[data-sg-stamp]').forEach((el) => { el.hidden = !hasDiscount; });
      if (hasDiscount) {
        set('[data-sg-was]', v.compare);
        set('[data-sg-save]', v.save);
        set('[data-sg-pct]', `−${v.pct}%`);
      }
      set('[data-sg-off-price]', v.off_price);
      this.renderDims(v);
      this.renderSpecs();
      set('[data-sg-sku]', v.sku || '');
      this.loadDelivery(v.sku);

      if (this.idInput) this.idInput.value = v.id;
      if (this.add) {
        this.add.disabled = !v.available;
        this.add.querySelector('span').textContent = v.available ? this.add.dataset.labelAdd : this.add.dataset.labelSold;
      }
      if (this.now) {
        this.now.hidden = !v.available;
        this.syncNow();
      }

      this.filterGallery(v);
      if (changed) {
        if (v.media_id) this.showMedia(String(v.media_id));
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      }
    }

    renderDims(v) {
      const d = v.dims || {};
      ['w', 'd', 'h'].forEach((k) => {
        this.querySelectorAll(`[data-sg-dim="${k}"]`).forEach((el) => { el.textContent = d[k] || ''; });
        this.querySelectorAll(`[data-sg-dim-chip="${k}"]`).forEach((el) => { el.hidden = !d[k]; });
      });
      const total = [d.w, d.d, d.h].filter(Boolean).join(' × ');
      this.querySelectorAll('[data-sg-dim-total]').forEach((el) => {
        el.textContent = total;
        if (el.parentElement) el.parentElement.hidden = !total;
      });
      this.total = total;
    }

    renderSpecs() {
      const unit = (this.querySelector('.sg-pdp__measures-total small') || {}).textContent || '';
      this.querySelectorAll('[data-sg-spec="option"]').forEach((li) => {
        const key = li.dataset.key;
        const field = [...this.querySelectorAll('.sg-pdp__option')].find((f) => (f.dataset.optionName || '').includes(key));
        const checked = field && field.querySelector('input:checked');
        const value = checked ? checked.value : '';
        li.querySelector('[data-sg-spec-value]').textContent = value;
        li.hidden = !value;
      });
      this.querySelectorAll('[data-sg-spec="dimensions"]').forEach((li) => {
        const text = this.total ? `${this.total} ${unit.toLowerCase()}` : '';
        li.querySelector('[data-sg-spec-value]').textContent = text;
        li.hidden = !text;
      });
    }

    /* Cada variante abre el grupo de fotos que empieza en su imagen y termina donde empieza la de otra variante. */
    filterGallery(v) {
      const ids = this.slides.map((s) => s.dataset.mediaId);
      const starts = [...new Set(this.variants.map((x) => ids.indexOf(String(x.media_id))).filter((i) => i >= 0))].sort((a, b) => a - b);
      const from = ids.indexOf(String(v.media_id));
      let range = null;
      if (starts.length > 1 && from >= 0) {
        const next = starts.find((i) => i > from);
        range = [starts[0] === from ? 0 : from, next === undefined ? ids.length : next];
      }
      this.slides.forEach((s, i) => { s.hidden = !!range && (i < range[0] || i >= range[1]); });
      this.thumbs.forEach((t, i) => { t.parentElement.hidden = !!range && (i < range[0] || i >= range[1]); });
    }

    showMedia(id) {
      if (!this.slides.some((s) => s.dataset.mediaId === String(id))) return;
      this.slides.forEach((s) => s.classList.toggle('is-on', s.dataset.mediaId === String(id)));
      this.thumbs.forEach((t) => t.classList.toggle('is-on', t.dataset.mediaId === String(id)));
    }

    initDiagram() {
      const box = this.querySelector('[data-sg-diagram]');
      if (!box) return;
      const dialog = box.querySelector('[data-sg-diagram-dialog]');
      const open = box.querySelector('[data-sg-diagram-open]');
      const close = box.querySelector('[data-sg-diagram-close]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      open.addEventListener('click', () => dialog.showModal());
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
    }

    initShare() {
      const btn = this.querySelector('[data-sg-share]');
      if (!btn) return;
      btn.addEventListener('click', async () => {
        const url = window.location.href;
        if (navigator.share) {
          try { await navigator.share({ title: btn.dataset.title, url }); } catch (e) { /* cancelado */ }
          return;
        }
        try { await navigator.clipboard.writeText(url); } catch (e) { return; }
        btn.setAttribute('data-copied-on', '');
        setTimeout(() => btn.removeAttribute('data-copied-on'), 1800);
      });
    }

    initGuide() {
      this.guide = this.querySelector('[data-sg-guide]');
      if (!this.guide) return;
      this.touched = new Set();
      this.querySelectorAll('.sg-pdp__option').forEach((field) => {
        field.addEventListener('change', () => {
          this.touched.add(Number(field.dataset.optionIndex));
          this.updateGuide();
        });
      });
    }

    updateGuide() {
      const steps = [...this.guide.querySelectorAll('.sg-pdp__step')];
      const options = steps.filter((s) => s.dataset.guideIndex !== undefined);
      let activeSet = false;
      options.forEach((step) => {
        const done = this.touched.has(Number(step.dataset.guideIndex));
        step.classList.toggle('is-done', done);
        const active = !done && !activeSet;
        step.classList.toggle('is-active', active);
        if (active) activeSet = true;
      });
      const final = this.guide.querySelector('[data-guide-final]');
      final.classList.toggle('is-active', !activeSet);
    }

    loadDelivery(sku) {
      const box = this.querySelector('[data-sg-delivery]');
      if (!box) return;
      const api = box.dataset.api;
      if (!api || !sku) { box.hidden = true; return; }
      if (this.deliverySku === sku) return;
      this.deliverySku = sku;
      fetch(api + encodeURIComponent(sku))
        .then((r) => (r.ok ? r.text() : ''))
        .then((text) => {
          const days = String(text || '').replace(/"/g, '').trim();
          if (!days || days.length > 12) { box.hidden = true; return; }
          box.querySelector('[data-sg-delivery-days]').textContent = days;
          box.hidden = false;
        })
        .catch(() => { box.hidden = true; });
    }

    initDims() {
      const btn = this.querySelector('[data-sg-dims-toggle]');
      const dims = this.querySelector('[data-sg-dims]');
      if (!btn || !dims) return;
      btn.addEventListener('click', () => {
        const on = btn.getAttribute('aria-pressed') !== 'true';
        btn.setAttribute('aria-pressed', String(on));
        dims.hidden = !on;
      });
    }

    initFav() {
      const btn = this.querySelector('[data-sg-fav]');
      if (!btn) return;
      const key = 'sg-favs';
      const read = () => { try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; } };
      const write = (list) => { try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) { /* sin almacenamiento */ } };
      const handle = this.dataset.handle;
      btn.setAttribute('aria-pressed', String(read().includes(handle)));
      btn.addEventListener('click', () => {
        const list = read();
        const on = !list.includes(handle);
        write(on ? [...list, handle] : list.filter((h) => h !== handle));
        btn.setAttribute('aria-pressed', String(on));
      });
    }

    initCountdown() {
      this.tiles = this.querySelectorAll('[data-sg-cd]');
      this.end = this.dataset.end ? Date.parse(this.dataset.end) : NaN;
      this.skew = this.dataset.serverNow ? Number(this.dataset.serverNow) * 1000 - Date.now() : 0;
      if (!this.tiles.length || Number.isNaN(this.end)) return;
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    tick() {
      const total = Math.max(0, Math.floor((this.end - (Date.now() + this.skew)) / 1000));
      const parts = {
        days: Math.floor(total / 86400),
        hours: Math.floor((total % 86400) / 3600),
        minutes: Math.floor((total % 3600) / 60),
        seconds: total % 60,
      };
      this.tiles.forEach((tile) => {
        const text = String(parts[tile.dataset.sgCd]).padStart(2, '0');
        const num = tile.querySelector('.sg-cd__num');
        if (num.textContent === text) return;
        const first = !tile.dataset.ready;
        num.textContent = text;
        tile.dataset.ready = 'true';
        if (first) return;
        tile.classList.remove('is-tick');
        void tile.offsetWidth;
        tile.classList.add('is-tick');
      });
      if (total === 0) clearInterval(this.timer);
    }
  }

  customElements.define('sg-pdp', SgPdp);
}
